import { Directive, ElementRef, HostListener, Input, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[InputTwoDecimal]'
})

export class InputTwoDecimalDirective {
    @Input() maxValue: number;
    @Input() maxLength: number;
    @Input() setEmptyToZero: boolean;
    @Output() updateTwoDecimalValue: EventEmitter < any > = new EventEmitter();

    constructor(private el: ElementRef) { }

    @HostListener("input")
    onInput() {
        // for input elements
        if (this.el.nativeElement.value) {
            this.el.nativeElement.value = this.getValueOnInput(this.el.nativeElement.value);
            if (this.el.nativeElement.value[this.el.nativeElement.value.length - 1] !== '.'
            && !(this.el.nativeElement.value.indexOf('.0') !== -1 && this.el.nativeElement.value[this.el.nativeElement.value.length - 1] === '0')) {
                this.updateTwoDecimalValue.emit(this.el.nativeElement.value);
            }
        }
        // for mdl-textfield input elements
        else if (this.el.nativeElement.children[0].children[0].value) {
            this.el.nativeElement.children[0].children[0].value = this.getValueOnInput(this.el.nativeElement.children[0].children[0].value);
            if (this.el.nativeElement.children[0].children[0].value[this.el.nativeElement.children[0].children[0].value.length - 1] !== '.'
                && !(this.el.nativeElement.children[0].children[0].value.indexOf('.0') !== -1 && this.el.nativeElement.children[0].children[0].value[this.el.nativeElement.children[0].children[0].value.length - 1] === '0')) {
                this.updateTwoDecimalValue.emit(this.el.nativeElement.children[0].children[0].value);
            }
        }
    }

    getValueOnInput(value: any) {
        let outputValue = value.slice(0, value.split(".")[0].length + 3);
        let decimalValue = value.split(".")[1];
        let maxCheckValue: any;

        // remove initial integer 0
        if (outputValue.split(".")[0][0] === '0' && outputValue.split(".")[0].length > 1) {
            outputValue = outputValue.slice(1, outputValue.length);
        }

        if (this.maxValue) {
            maxCheckValue = this.maxValue;
        } else if (this.maxLength) {
            maxCheckValue = Math.pow(10, this.maxLength) - 0.01;
        }

        if (parseFloat(outputValue.split(".")[0]) === parseFloat(maxCheckValue)) {
            outputValue = outputValue.split(".")[0];
        } else if (parseFloat(outputValue) > parseFloat(maxCheckValue)) {
            outputValue = (outputValue - outputValue % 10) / 10;

            // in cases of altering within max value
            if (parseFloat(outputValue) > parseFloat(maxCheckValue)) {
                outputValue = maxCheckValue;
            }

            if (decimalValue && decimalValue !== '') {
                outputValue += '.' + decimalValue;
            }
        }

        return outputValue;
    }


    @HostListener("change")
    onChange() {
        // for input elements
        if (this.el.nativeElement.value || this.el.nativeElement.value === '') {
            this.el.nativeElement.value = this.getValueOnChange(this.el.nativeElement.value);
            this.updateTwoDecimalValue.emit(this.el.nativeElement.value);
        }
        // for mdl-textfield input elements
        else if (this.el.nativeElement.children[0].children[0].value || this.el.nativeElement.children[0].children[0].value === '') {
            this.el.nativeElement.children[0].children[0].value = this.getValueOnChange(this.el.nativeElement.children[0].children[0].value);
            this.updateTwoDecimalValue.emit(this.el.nativeElement.children[0].children[0].value);
        }
    }

    getValueOnChange(value: any) {
        let returnValue = parseFloat(value),
            emptyReturnValue = this.setEmptyToZero ? 0 : '';

        return isNaN(returnValue) ? emptyReturnValue : returnValue;
    }
}